import React from 'react'
import theme from '../../themes/default'
import { StyledLoader } from './style'

const BackdropLoader = () =>
  <div className="fade modal-backdrop show">
    <StyledLoader
      type="Oval"
      height={30}
      color={theme.palette.white[0]}
    />
  </div>


export default BackdropLoader
